import {createCrud} from "./CRUD";

const initialState = { items: [], item: {} };

let {constants, actions, reducer} =
    createCrud(
        '/main/reference-reviews/',
        'ReferenceReview',
        'ReferenceReviews',
        initialState);

export const referenceReviewConstants = constants;
export const referenceReviewActions = actions;
export const referenceReviewReducer = reducer;
